/**
 * Route constants for the Managed Kubernetes **v2** console.
 *
 * Unlike v1 (`/services/kubernetes/:serviceId/...`), there is **no serviceId
 * segment**: the backend resolves the tenant from the JWT org claim, and an org
 * has exactly one workspace. That also means no service picker — the module
 * mounts straight onto its base path.
 */
export const K8S_V2_BASE = '/services/kubernetes/v2';

/**
 * VPCs and the subnets carved from them — module-level, not per-cluster: a
 * subnet is what several clusters can run in, and it outlives any of them.
 *
 * This is the only networking page the module has. A Networks page and a
 * Routers page were tried and taken out: both were a second copy of what the
 * Cloud Compute console owns, and both led with actions that make something a
 * cluster cannot use.
 */
export const K8S_V2_VPCS = `${K8S_V2_BASE}/vpcs`;

export const clusterPath = (clusterId: string) => `${K8S_V2_BASE}/clusters/${clusterId}`;
export const clusterTabPath = (clusterId: string, slug: string) =>
  slug ? `${clusterPath(clusterId)}/${slug}` : clusterPath(clusterId);

type Id = string | number | undefined;

/** What `src/app/paths.ts` merges into the one `paths` object; the constants above stay the in-module names. */
export const kubernetesPaths = {
  base: '/services/kubernetes',
  /** One v1 cluster, under its service. */
  cluster: (serviceUuid: Id, clusterId: Id) => `/services/kubernetes/${serviceUuid}/clusters/${clusterId}`,
  v2: { base: K8S_V2_BASE, cluster: clusterPath },
} as const;
